// extracted by mini-css-extract-plugin
export default {"report_class":"customer_report_class__rhh9e","pbiLoadingPlaceholder":"customer_pbiLoadingPlaceholder__2oKFb","fadeInOut":"customer_fadeInOut__hHkEO"};